import { useCallback } from "react";

import { fetchJson } from "@sprint1/pkg/src/fetch/fetchJson";
import { useFetchJsonAsync } from "@sprint1/pkg/src/fetch/useFetchJsonAsync";
//__convertToQueryString__ import { convertToQueryString } from "@sprint1/pkg/src/url/convertToQueryString";

import { AssignToTechnicianRequest } from "api/types/assignToTechnicianRequest";

export function assignToTechnician(arg: AssignToTechnicianArgType) {
  //__queryString__
  return fetchJson<void>(`/api/SiteSurvey/AssignToTechnician`, {
    method: "POST",
    body: arg.request,
  });
}

export function useAssignToTechnician(arg?: UseAssignToTechnicianArgType) {
  const { run, ...rest } = useFetchJsonAsync({
    runOnMount: arg?.runOnMount,
    asyncFn: arg?.runOnMount ? () => assignToTechnician(arg) : undefined,
  });

  const assignToTechnicianCb = useCallback(
    (arg: AssignToTechnicianArgType) => {
      return run(() => assignToTechnician(arg));
    },
    [run]
  );
  return {
    ...rest,
    assignToTechnician: assignToTechnicianCb,
    data: rest?.fetchJsonResponse?.data,
  };
}

export interface AssignToTechnicianArgType {
  request: AssignToTechnicianRequest;
}

export type UseAssignToTechnicianArgType = { runOnMount: false } | ({ runOnMount: true } & AssignToTechnicianArgType);
